<template>
    <tr>
        <td class="is-hidden-mobile is-hidden-tablet-only">
            {{ row.dteRegisteredDate | formatDate }}
        </td>
        <td class="is-hidden-mobile is-hidden-tablet-only">
            {{ row.strDescription }}
        </td>
        <td class="is-hidden-desktop">
            <span class="has-text-weight-semibold">
                {{ row.dteRegisteredDate | formatDate }}
            </span>
            <br />
            {{ row.strDescription }}
        </td>
        <td>
            &pound;{{ row.dblEstimatedCost | currency }}
        </td>
        <td>
            {{ row.strJobStatus }}
        </td>
        <td>
            {{ row.dteCompleted | formatDate }}
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
};
</script>
